import { Grid, FormControl } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import {
  FiltersLayout,
  FiltersButtons,
  SearchField,
  DateRangePicker,
  DocumentStatuses,
  ActivityTypeDropdown
} from '../../../components';
import { IDateRange } from '../../../models';

interface IContractFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  selectedDateRange?: IDateRange | null;
  setSelectedDateRange?: Dispatch<SetStateAction<IDateRange>>;
  searchPlaceholder?: string;
  setSelectedDocumentStatus?: (val: string | number) => void;
  selectedDocumentStatus?: string | number;
  setSelectedActivityType?: (val: string | number) => void;
  selectedActivityType?: string | number;
}

export const ContractFilters: FC<IContractFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  selectedDateRange,
  setSelectedDateRange,
  searchPlaceholder,
  setSelectedDocumentStatus,
  selectedDocumentStatus,
  setSelectedActivityType,
  selectedActivityType
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      {setSelectedDocumentStatus && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <DocumentStatuses
            isDisabled={isLoading}
            value={selectedDocumentStatus}
            handleChange={value => {
              setSelectedDocumentStatus(value);
            }}
          />
        </Grid>
      )}
      {setSelectedDocumentStatus && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <ActivityTypeDropdown
            isDisabled={isLoading}
            value={selectedActivityType}
            handleChange={value => {
              setSelectedActivityType(value);
            }}
            id="contract-filters"
          />
        </Grid>
      )}
      {setSelectedDateRange && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <DateRangePicker
              id="filterDateRange"
              label="Date Range"
              value={selectedDateRange}
              isDisabled={isLoading}
              onChange={value => {
                setSelectedDateRange(value);
              }}
              fullWidth
              inputSize="small"
            />
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedDocumentStatus && setSelectedDocumentStatus('');
            setSelectedActivityType && setSelectedActivityType('');
            setSelectedDateRange &&
              setSelectedDateRange({
                startDate: null,
                endDate: null,
                key: 'selection',
                inputValue: ''
              });
            setSearchedValue && setSearchedValue('');
            setSearchValue && setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
